// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.walletHistory {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 2rem;
}
@media (max-width: 991px) {
  .walletHistory {
    padding: 0.1rem;
  }
}
.walletHistory .loadingContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 6rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Transaction/transaction.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAAJ;AAEI;EANJ;IAOQ,eAAA;EACN;AACF;AACI;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;AACR","sourcesContent":["\n.walletHistory {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 2rem;\n\n    @media (max-width: 991px ) {\n        padding: 0.1rem;\n    }\n\n    .loadingContainer {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        padding: 6rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
